module.exports = __webpack_public_path__ + "img/byh-10-3_15.prt.b4edf357.jpg";